export default __webpack_public_path__ + "static/media/fusion.f1778f72.webp";